<template>
  <div>
    <v-progress-circular v-if="!config" indeterminate class="primary--text"></v-progress-circular>
    <div v-else>

      <v-card color="grey lighten-4" flat tile>
        <v-toolbar color="orange lighten-4" dense>
          <v-menu :nudge-width="100">
            <template v-slot:activator="{ on }">
            <v-toolbar-title v-on="on">
              <span>{{$route.params.app | capitalize}}</span>
              <v-icon light>arrow_drop_down</v-icon>
            </v-toolbar-title>
            </template>
            <v-list>
              <v-list-item v-for="app in apps" :key="app" @click.native="switchApp(app)">
                <v-list-item-title>{{app | capitalize }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>          
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>search</v-icon>
          </v-btn>
        </v-toolbar>

        <div v-if="$route.params.app === 'consumer'">
          <isrs-texts-dialog
            :baseUrl="baseUrl"
            :texts="config.texts || {}"
            @saveTexts="texts => saveTexts(texts)"
          >
          </isrs-texts-dialog>
        </div>

        <div v-if="$route.params.app === 'mail'">
          <isrs-mail-texts-dialog 
            :baseUrl="baseUrl" 
            :texts="config.mailTexts"
            @saveMailTexts="texts => saveMailTexts(texts)"
          ></isrs-mail-texts-dialog>
        </div>


      </v-card>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import IsrsTextsDialog from '../../components/IsrsTextsDialog.vue'
import IsrsMailTextsDialog from '../../components/IsrsMailTextsDialog.vue'

export default {
  data() {
    return {
      apps: ['consumer', 'mail'],
      drawer: true,
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' }
      ],
      links: ['Home', 'Contacts', 'Settings'],
      mini: true,
      right: null
    }
  },

  components: {
    IsrsTextsDialog,
    IsrsMailTextsDialog
  },

  created() {
    this.fetchConfig()
  },

  computed: {
    ...mapGetters('returnShopPortal', ['configActivated', 'config']),
    ...mapState('returnShopPortal', []),
    ...mapState('texts', ['accordionKeys']),
    baseUrl() {
      return `/returnshopportals/${this.$route.params.returnShopPortalId}`
    }
  },

  methods: {
    ...mapActions('returnShopPortal', ['fetchConfig', 'saveConfig']),
    saveTexts(texts) {
      this.config.texts = texts
      this.saveConfig(this.config)
    },
    saveMailTexts(texts) {
      this.config.mailTexts = texts
      this.saveConfig(this.config)
    },
    switchApp(app) {
      console.log('change url:', app, `${this.baseUrl}/texts/${app}`)

      this.$router.push( {path: `${this.baseUrl}/texts/${app}`})

      // return `#${this.baseUrl}/texts/${item.title}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// Texts.vue?482e3db4